import { useMemo } from 'react';
import {
  useZustandModalKitStore,
  zustandModalKitSelector,
  useTranslate,
  formattedDate,
} from 'react-gldn-kit';

import { BONUS_INFO_RESPONSE, IGNORED_KEYS } from './constants';
import {
  AdaptedBonusInfoResponse,
  EBonusType,
} from 'components/ui/Bonuses/BonusOnDeposit/types';
import { PromoCodeRowProps } from '../../../PromoCode/PromoCodeActivateModal/components/PromoCodeRow';
import { BASE_IMG_URL } from 'constants/image';
import { getBonusImagePath } from 'utils/icons';
import { useZustandUserStore } from 'stores/user/personal/store';
import { getUserCurrencyNameSelector } from 'stores/user/personal/selectors';

import styles from './BonusInfo.module.css';

const BonusInfo = () => {
  const { getText } = useTranslate('', '');

  const currencyName = useZustandUserStore(getUserCurrencyNameSelector);

  const {
    typeBonus,
    ...rest
  }: { [key: string]: string | number; typeBonus: EBonusType } =
    useZustandModalKitStore(
      zustandModalKitSelector.getModalAdditionalInfoSelector
    ) ||
    ({
      typeBonus: EBonusType.Undefined,
    } as AdaptedBonusInfoResponse);

  const list: PromoCodeRowProps[] = useMemo(() => {
    if (typeBonus === EBonusType.Undefined) {
      return [];
    }
    const keys = Object.keys(rest) as Array<keyof AdaptedBonusInfoResponse>;

    const list: PromoCodeRowProps[] = [];

    keys.forEach((key) => {
      const isDate = key === 'bonusTime';

      if (typeBonus === EBonusType.RakeBackBoost && key === 'bonusOdd') {
        return true;
      }

      if (IGNORED_KEYS.includes(key)) {
        return;
      }

      const formatDate = isDate ? formattedDate(+rest[key]) : ['', ''];

      const value = isDate
        ? `${formatDate[0]} ${getText('counter.dd')} ${formatDate[1]} ${getText(
            'counter.hh'
          )}`
        : rest[key];

      if (+value < 0) {
        return true;
      }

      if (rest[key]) {
        let finalValue =
          key === 'bonusOdd' ? value + '%' : `${currencyName}` + value;

        if (key === 'wager') {
          finalValue = 'x' + value;
        }

        list.push({
          title: `bonusCabinet.info.${key}`,
          value: finalValue,
        });
      }
    });

    switch (typeBonus) {
      case EBonusType.BonusOnDeposit:
      case EBonusType.RakeBackBoost:
      case EBonusType.RakeBack:
      case EBonusType.Battle:
      case EBonusType.Weekly:
      case EBonusType.FreeSpins:
      case EBonusType.Monthly:
      case EBonusType.Support:
        return [...list];

      default:
        return list;
    }
  }, [typeBonus, rest]);

  const AdditionalInfo = BONUS_INFO_RESPONSE[typeBonus];

  return (
    <div className={styles.wrapperBonusInfo}>
      <img
        src={`${BASE_IMG_URL}/bonuses/${getBonusImagePath(typeBonus)}`}
        className={styles.img}
      />

      <AdditionalInfo list={list} specV={rest.bonusOdd} />
    </div>
  );
};

export default BonusInfo;
